// Her sayfanın üst bloğu aynı ritimde dursun diye.
export default function PageHeader({ baslik, altBaslik, children }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 mb-6">
      <div className="min-w-0">
        <h1 className="text-xl font-semibold tracking-tight text-slate-900">{baslik}</h1>
        {altBaslik && <p className="text-sm text-slate-500 mt-0.5">{altBaslik}</p>}
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}
